import BankAccount from './bankAccount';

export default function Bank(data) {
    let bank = data || {};
    this.type = "Banques";
    this.isMain = bank.isMain;
    this.accounts = bank.accounts !== undefined && bank.accounts !== null && bank.accounts.length !== 0 ? bank.accounts.map(b => new BankAccount(b)): [];
}